
















import SlideshowItem from '@/components/SlideshowItem'

export default {
    name: 'Slideshow'

    props: ['document']

    components:
        SlideshowItem: SlideshowItem

    data: -> fields: @defaultFields

    computed:
        useBlend: -> @fields.image_blend is 'eingeschaltet'
        isDark: -> @fields.background_color isnt 'hell'
        isScreenWidth: -> @fields.width is 'Bildschirm'
        isPageWidth: -> @fields.width is 'Seite'
        isTextWidth: -> @fields.width is 'Text'

        slideshowOptions: ->
            options = 
                'autoplay': true
                'autoplay-interval': 5000
            
            if @fields.height is 'groß' 
                options.ratio = '7:3'
                options.minHeight = 375
            else 
                options.ratio = '3:1'
                options.minHeight = 280 
            
            options


        containerClass: ->
            'uk-container': @isPageWidth
            'uk-container uk-container-small': @isTextWidth

    methods:
        defaultFields: ->
            height: 'groß'
            width: 'Bildschirm'
            image_blend: 'eingeschaltet'
            items: []

        setContent: (document) ->
            fields = 
                width: document.primary.width
                height: document.primary.height
                image_blend: document.primary.image_blend
                background_color: document.primary.background_color1
                items: document.items
            $.extend @fields, fields
    
    mounted: ->
        UIkit.slideshow @$refs.slideshow, @slideshowOptions

    created: ->
        @setContent @document
}
